const PaintDivider = ({ color = "#0f0d0dff" }) => {
  return (
    <svg
      viewBox="0 0 1440 120"
      preserveAspectRatio="none"
      className="paint-divider"
    >
      <path
        d="
          M0,40
          C80,60 160,20 240,40
          C320,60 400,20 480,40
          C560,60 640,20 720,40
          C800,60 880,20 960,40
          C1040,60 1120,20 1200,40
          C1280,60 1360,20 1440,40
          L1440,120
          L0,120
          Z
        "
        fill={color}
      />
    </svg>
  );
};

export default PaintDivider;
